/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const CurrentEntryPathSegment = styled.span`
  font-weight: 600;
`;

export const LinkedPathSegment = styled.span`
  & a,
  & a:hover,
  & a:focus {
    color: ${token('color.text', colors.N800)};
    cursor: pointer;
  }
`;
